import { Injectable } from '@angular/core';
import { GetCaptchaInfo, IGetCaptchaInfo } from 'client/models/form/captcha.model';
import { Observable, map } from 'rxjs';

import { prepareQuestionnaireApiUrl } from '../app.const';
import { AppHttpClient } from 'common/service/app-http-client.service';
import { QuestionnaireInfo, IQuestionnaireResponseHttp, IQuestionnaireSaveRequestHttp } from 'questionnaire/model/questionnaire.model';

const HttpServiceMethods = {
  getQuestionnaireInfoUrl: () => prepareQuestionnaireApiUrl(`GetQuestionnaireInfoForm`),
  saveQuestionnaireAnswerUrl: () => prepareQuestionnaireApiUrl('SaveQuestionnaireAnswer'),
  getCaptchaInfoUrl: () => prepareQuestionnaireApiUrl('GetQuestionnaireCaptchaInfo'),
};
@Injectable()
export class QuestionnaireService {

  constructor(private httpService: AppHttpClient) { }

  public getQuestionnaireInfo(): Observable<QuestionnaireInfo[]> {
    return this.httpService
      .get<IQuestionnaireResponseHttp[]>(HttpServiceMethods.getQuestionnaireInfoUrl())
      .pipe(map((items) => items.map(item => QuestionnaireInfo.fromJson(item))));
  }

  public saveQuestionnaireAnswer(body: IQuestionnaireSaveRequestHttp
  ): Observable<{ message: string }> {
    return this.httpService.post<{ message: string }>(HttpServiceMethods.saveQuestionnaireAnswerUrl(), body);
  }

  public getCaptchaInfo(): Observable<GetCaptchaInfo> {
    return this.httpService
      .get<IGetCaptchaInfo>(HttpServiceMethods.getCaptchaInfoUrl())
      .pipe(map((item) => GetCaptchaInfo.fromJson(item)));
  }

}
